import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const ServiceUnavailableError = ({ titleTextId }) => <ErrorPage
  title="Platform Access Not Activated"
  titleTextId={ titleTextId }
  type="server"
  showButton
  onButtonClick={ () => history.go(-1) }
>
  <LocalisedMessage id="unavailable.content" />
</ErrorPage>;

ServiceUnavailableError.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  history: PropTypes.shape({
    go: PropTypes.func,
  }).isRequired,
  titleTextId: PropTypes.string
};
ServiceUnavailableError.defaultProps = {
  titleTextId: 'unavailable.title'
};

export default injectIntl(ServiceUnavailableError);
